export default __webpack_public_path__ + "static/media/map.c2d522b1.png";